import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=f684a290&scoped=true"
import script from "./addOwner.vue?vue&type=script&lang=js"
export * from "./addOwner.vue?vue&type=script&lang=js"
import style0 from "./addOwner.vue?vue&type=style&index=0&id=f684a290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f684a290",
  null
  
)

export default component.exports